import { PageHeader } from "../components/PageHeader";
import { config } from "../lib/config";

export function Contact() {
  const phoneContent = config.contactPhone || "سيتم تحديثها قريباً";
  const addressContent = config.contactAddress || "سيتم تحديثها قريباً";

  return (
    <>
      <PageHeader
        eyebrow="تواصل معنا"
        title="قنوات التواصل الرسمية"
        description="قنوات التواصل العامة المعتمدة لوحدة تقييم الأصول العقارية."
      />
      <section className="py-20">
        <div className="container">
          <div className="grid gap-4 md:grid-cols-2">
            {config.contactEmail ? (
              <a className="rounded-lg border border-line p-6" href={`mailto:${config.contactEmail}`}>
                <span className="text-sm font-bold text-gold">البريد الرسمي</span>
                <strong className="mt-2 block text-charcoal">{config.contactEmail}</strong>
              </a>
            ) : null}
            {config.contactSecondaryEmail ? (
              <a
                className="rounded-lg border border-line p-6"
                href={`mailto:${config.contactSecondaryEmail}`}
              >
                <span className="text-sm font-bold text-gold">بريد التواصل</span>
                <strong className="mt-2 block text-charcoal">{config.contactSecondaryEmail}</strong>
              </a>
            ) : null}
            {config.contactPhone ? (
              <a className="rounded-lg border border-line p-6" href={`tel:${config.contactPhone}`}>
                <span className="text-sm font-bold text-gold">الهاتف</span>
                <strong className="mt-2 block text-charcoal">{phoneContent}</strong>
              </a>
            ) : (
              <div className="rounded-lg border border-line p-6">
                <span className="text-sm font-bold text-gold">الهاتف</span>
                <strong className="mt-2 block text-charcoal">{phoneContent}</strong>
              </div>
            )}
            <div className="rounded-lg border border-line p-6">
              <span className="text-sm font-bold text-gold">العنوان</span>
              <strong className="mt-2 block text-charcoal">{addressContent}</strong>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
